import { CustomBottomBar, MinimalStepper } from '@components';
import { Button, Checkbox, Container, Icon, Typography } from '@design-system';
import { LiaArrowLeftSolid } from 'react-icons/lia';
import './FormationPage.scss';
import { useFormationPageVM } from './useFormationPageVM';

export const FormationPage: React.FC = () => {
    const {
        computedStepperSteps,
        currentStep,
        steps,
        handleCheckboxChange,
        handlePrev,
        handleNext,
        canGoBack,
        currentStepContent,
        actualStep
    } = useFormationPageVM();

    return (
        <div className="security-formation-page">
            <Container className="formation-header" radius="none" column>
                <Typography intrinsic="h2" className="mb-large-spacing formation-header-title">
                    {computedStepperSteps[currentStep].label}
                </Typography>
                <MinimalStepper steps={computedStepperSteps} />
            </Container>

            <Container>
                <div className="formation-page-content">
                    {currentStep === 0 ? (
                        <Container className="checkboxes-container" bordered="grey" padding="medium large">
                            <Typography intrinsic="h3" className="mb-small-medium-spacing">
                                {steps[currentStep].label}
                            </Typography>
                            {steps[currentStep].checkboxes?.map((checkbox) => (
                                <Checkbox
                                    key={checkbox.label}
                                    label={checkbox.label}
                                    checked={checkbox.isChecked}
                                    onChange={() => handleCheckboxChange(currentStep, checkbox.label)}
                                    forcedCenter
                                />
                            ))}
                        </Container>
                    ) : (
                        <>
                            {currentStepContent &&
                                currentStepContent.reduce((containers, content, index) => {
                                    if (index % 2 === 0 && currentStepContent[index + 1]) {
                                        const risque = content;
                                        const prevention = currentStepContent[index + 1];

                                        containers.push(
                                            <Container
                                                className="content-container"
                                                bordered="grey"
                                                padding="medium large"
                                                key={`risk-prevention-${index}`}
                                            >
                                                <Typography intrinsic="h3" className="mb-small-medium-spacing">
                                                    {risque.description}
                                                </Typography>
                                                {prevention.description}
                                            </Container>
                                        );
                                    }
                                    return containers;
                                }, [] as JSX.Element[])}
                        </>
                    )}
                </div>
            </Container>

            <CustomBottomBar>
                <Button
                    color="marine"
                    variant="secondary"
                    onClick={handlePrev}
                    disabled={!canGoBack}
                    className="sm-bottom-bar-button mr-small-spacing"
                >
                    <Icon className="arrow-left" color="grey" icon={<LiaArrowLeftSolid />} size={30} />
                </Button>
                <Button
                    variant="primary"
                    color="marine"
                    size="fullwidth"
                    onClick={handleNext}
                    disabled={!actualStep?.isFilled}
                    className="next-button"
                >
                    <Typography intrinsic="h4">Suivant</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
